const COMMENTS_OPEN_KEY = 'jarvis.pdfViewer.commentsOpen';
const HIGHLIGHTS_VISIBLE_KEY = 'jarvis.pdfViewer.highlightsVisible';

/** Previous session-only key; migrated once into localStorage. */
const LEGACY_SESSION_COMMENTS_KEY = 'jarvis.pdfCommentsPanelOpen';

function readBoolPref(storageKey: string, legacySessionKey?: string): boolean {
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored === '0') return false;
    if (stored === '1') return true;

    if (legacySessionKey) {
      const legacy = sessionStorage.getItem(legacySessionKey);
      if (legacy === '0' || legacy === '1') {
        localStorage.setItem(storageKey, legacy);
        sessionStorage.removeItem(legacySessionKey);
        return legacy === '1';
      }
    }
  } catch {
    /* localStorage / sessionStorage may be unavailable */
  }
  return true;
}

function writeBoolPref(storageKey: string, value: boolean): void {
  try {
    localStorage.setItem(storageKey, value ? '1' : '0');
  } catch {
    /* ignore */
  }
}

/** Whether the PDF review comments panel is open (default: open). */
export function readPdfCommentsPanelOpen(): boolean {
  return readBoolPref(COMMENTS_OPEN_KEY, LEGACY_SESSION_COMMENTS_KEY);
}

export function writePdfCommentsPanelOpen(open: boolean): void {
  writeBoolPref(COMMENTS_OPEN_KEY, open);
}

/** Whether highlight overlays are visible on the PDF (default: visible). */
export function readPdfHighlightsVisible(): boolean {
  return readBoolPref(HIGHLIGHTS_VISIBLE_KEY);
}

export function writePdfHighlightsVisible(visible: boolean): void {
  writeBoolPref(HIGHLIGHTS_VISIBLE_KEY, visible);
}
